import { CommunicationDetailsPageProvider } from '../pages/CommunicationDetails/context/CommunicationDetailsPageContext';
import CommunicationDetails from '../pages/CommunicationDetails';

const CommunicationDetailsPageContainer = () => (
  <CommunicationDetailsPageProvider>
    <CommunicationDetails />
  </CommunicationDetailsPageProvider>
);

export default CommunicationDetailsPageContainer;
